import typography from "assets/theme/base/typography";
import pxToRem from "assets/theme/functions/pxToRem";

const { fontWeightBold, size } = typography;

const root = {
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  fontSize: size.xs,
  fontWeight: fontWeightBold,
  borderRadius: pxToRem(10),
  padding: `${pxToRem(10)} ${pxToRem(20)}`,
  lineHeight: 1.4,
  textAlign: "center",
  textTransform: "none",
  userSelect: "none",
  transition: "all 160ms ease",
  boxShadow: "none",
  "&:hover": {
    transform: "translateY(-1px)",
    boxShadow: "0 8px 18px rgba(15, 23, 42, 0.10)",
  },
  "&:active": { transform: "translateY(0)" },
  "&:disabled": { pointerEvents: "none", opacity: 0.55, boxShadow: "none" },
  "& .material-icons": { fontSize: pxToRem(16) },
};

export default root;
